import api from '../api';
import { addProduct, updateProduct, deleteProduct } from '../api';

export async function fetchSellerProducts(sellerId) {
  const res = await api.get(`/api/products/seller/${sellerId}`);
  return res.data;
}

export async function createProduct(formData) {
  return addProduct(formData);
}

export async function updateProductById(id, formData, sellerId) {
  return updateProduct(id, formData, sellerId);
}

export async function removeProduct(productId, sellerId) {
  return deleteProduct(productId, sellerId);
}